import React, {Fragment} from 'react';
import Gig from '../Gig';
import InfiniteScroll from 'react-infinite-scroll-component';

export const View = props => {
    const {gigs, reload, next, hasMore} = props
    const items = gigs.map((gig, index) => <Gig key={index} gig={gig}/>)
    return (
        <InfiniteScroll
            dataLength={gigs.length} //This is important field to render the next data
            next={next}
            hasMore={hasMore}
            height='800px'
            loader={<h4>Loading...</h4>}
            endMessage={
                <p style={{textAlign: 'center'}}>
                    <b>Yay! You have seen it all</b>
                </p>
            }
            refreshFunction={reload}
            pullDownToRefresh
            pullDownToRefreshContent={
                <h3 style={{textAlign: 'center'}}>&#8595; Pull down to refresh</h3>
            }
            releaseToRefreshContent={
                <h3 style={{textAlign: 'center'}}>&#8593; Release to refresh</h3>
            }
            scrollableTarget="gigscroll"
        >
            {items}
        </InfiniteScroll>
    );
}
